// src/components/AppointmentCTA.jsx
export default function AppointmentCTA() {
  return (
    <section className="bg-emerald-600 text-white py-12 px-6 md:px-12 text-center">
      <h2 className="text-2xl md:text-3xl font-bold mb-4">Book an Appointment Today</h2>
      <p className="mb-6 text-lg">Consult with Dr. Nidhi Malviya for personalized and holistic homeopathic care.</p>
      <div className="flex justify-center gap-4 flex-wrap">
        <a
          href="tel:+918319789552"
          className="bg-white text-emerald-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition"
        >
          📞 Call Now
        </a>
        <a
          href="https://wa.me/918319789552"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white text-emerald-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition"
        >
          💬 WhatsApp Chat
        </a>
      </div>
    </section>
  );
}
